import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="sortable"
export default class extends Controller {
  static targets = ["input"]

  connect() {
    this.inputTarget.addEventListener("focus",     this.hidePointer)
    this.inputTarget.addEventListener("mousemove", this.showPointer)
    this.inputTarget.addEventListener("blur",      this.showPointer)
    this.inputTarget.addEventListener("keydown",   this.handleKeydown)
  }

  disconnect() {
    this.inputTarget.removeEventListener("focus",     this.hidePointer)
    this.inputTarget.removeEventListener("mousemove", this.showPointer)
    this.inputTarget.removeEventListener("blur",      this.showPointer)
    this.inputTarget.removeEventListener("keydown",   this.handleKeydown)
  }

  handleKeydown = (event) => {
    switch (event.key) {
      case "Enter":
        event.preventDefault()
        this.inputTarget.dispatchEvent(new Event("change", { bubbles: true }))
        break

      case "+":
      case "=": // Shift + +
      case "ArrowUp":
      case "PageUp":
        this.increment(event)
        break

      case "-":
      case "_":
      case "ArrowDown":
      case "PageDown":
        this.decrement(event)
        break
    }
  }

  hidePointer = () => {
    this.inputTarget.classList.add("hide-pointer")
  }

  showPointer = () => {
    this.inputTarget.classList.remove("hide-pointer")
  }

  decrement(event) {
    event.preventDefault()
    this.inputTarget.dispatchEvent(new CustomEvent("decimal-input:decrement", { bubbles: true }));
  }

  increment(event) {
    event.preventDefault()
    this.inputTarget.dispatchEvent(new CustomEvent("decimal-input:increment", { bubbles: true }));
  }
}
